// extracted by mini-css-extract-plugin
module.exports = {"title":"post-section_title__R_QGE","text":"post-section_text__C7og4","section":"post-section_section__dOfd0"};